import React from 'react';
import _ from 'lodash';
import { Field } from 'redux-form';
import { Form, WppGrid, WppIconInfo, WppTypography, WppButton, WppInlineMessage } from 'buildingBlocks';
import FormDropdown from 'components/FormDropdown';
import { COPILOT_COLORS } from 'globalStyles';
import { ArrayDataProvider } from 'buildingBlocks/TwoListMultiSelect/DataProvider';
import { REPORT_METRICS, REPORT_DIMENSIONS, REPORT_INTERVAL } from '../constants';
import { AudienceReportMultiSelect } from './AudienceReportMultiSelect';
import { hyperLinkText, audianceRoportMessageContainer, downloadReportBtn, inlineMessageStyle, lableStyle } from '../style';

const { WPP } = COPILOT_COLORS;

const metricsDataProvider = new ArrayDataProvider(_.values(REPORT_METRICS));
const dimensionsDataProvider = new ArrayDataProvider(_.values(REPORT_DIMENSIONS));

const WIKI_LINK = `
  https://copilotsupport.freshdesk.com/support/solutions/articles/47001125170-general-strategy-analytics
`;

type Props = {
  canDownload: boolean
};

const AudienceReportForm = ({ canDownload }: Props) => (
  <>
    <WppGrid container fullWidth item all={18}>
      <div style={audianceRoportMessageContainer}>
        <WppIconInfo /><WppTypography tag="p" type="s-body">View performance metrics related to individual targeted and untargeted segments that saw an impression.</WppTypography>
        <WppTypography style={hyperLinkText} tag="p" type="s-body">
          <a href={WIKI_LINK} target="_blank" rel="noopener noreferrer" style={{ color: WPP.blue500 }}>
            READ MORE
          </a>
        </WppTypography>
      </div>
    </WppGrid>
    <WppGrid container fullWidth item all={24}>
      <WppGrid item all={8}>
        <Form.Field>
          <WppTypography type="s-strong" style={lableStyle}>Metric Columns</WppTypography>
          <AudienceReportMultiSelect
            name="reportMetrics"
            dataProvider={metricsDataProvider}
            placeholder="Select Metric Columns"
          />
        </Form.Field>
      </WppGrid>
      <WppGrid item all={8}>
        <Form.Field>
          <WppTypography type="s-strong" style={lableStyle}>Additional Metric Columns</WppTypography>
          <AudienceReportMultiSelect
            name="reportDimensions"
            dataProvider={dimensionsDataProvider}
            placeholder="Select Additional Metric Columns"
          />
        </Form.Field>
      </WppGrid>
      <WppGrid item all={4}>
        <Form.Field>
          <WppTypography type="s-strong" style={lableStyle}>Time Frame</WppTypography>
          <Field
            name="reportInterval"
            component={FormDropdown}
            options={_.values(REPORT_INTERVAL)}
            selection
            fluid
          />
        </Form.Field>
      </WppGrid>
      <WppGrid item all={4} style={downloadReportBtn}>
        <WppButton disabled={!canDownload} type="submit">Download Report</WppButton>
      </WppGrid>
      <WppInlineMessage size="s" message="The following columns are included in the report by default: Date, Segment Name, Segment ID, Impressions, and Targeted." type="information" showTooltipFrom={1000} style={inlineMessageStyle} />
    </WppGrid>
  </>
);

export default AudienceReportForm;
